import { Component, Input } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { IS1InputSelectItem } from '@app/s1';
import { TrattaService, IRicercaTrattaParams } from '@app/shared/services/tratta.service';

@Component({
  selector: 'ser-tratta-select',
  templateUrl: './tratta-select.component.html',
  styleUrl: './tratta-select.component.scss'
})
export class TrattaSelectComponent {

  @Input() control: UntypedFormControl;
  @Input() readonly: boolean;
  @Input() label: string = 'tratte.title.dettaglio';

  tratte: IS1InputSelectItem[];

  constructor(private trattaService: TrattaService) { }

  ngOnInit(): void { 
    this.loadItems();
  }

  loadItems() {

    const params: IRicercaTrattaParams = {
      page: 1,
      pageSize: 999
    }
  
    this.trattaService.ricerca(params).subscribe(trattePaginate => {
  
      this.tratte = trattePaginate?.elements?.map(tratta => { 
        return { code: tratta.id, label: tratta.descrizione?.trim() }  
      }) ?? [];
  
      if (this.tratte?.length == 1) {
        this.control?.patchValue(this.tratte[0].code);
      }
  
    })

  }

}
